export class ObjetControle {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        idNature: { key: 'idNature' }
    };

    id: number;
    code: string;
    libelle: string;
    idNature: number;
}
